import EditorOverlayStateEnum from '../EditorOverlayConstants';
import {
  ACTION_MODE_MAP,
  SET_EDITOR_MODE,
  ENABLE_EDIT,
  ENABLE_VIEW,
  ENABLE_SIGN,
  ENABLE_REQUEST_SIGNATURE,
  ENABLE_REQUEST_SIGNATURE_WAIT,
  ENABLE_REQUEST_SIGNATURE_FILL,
  ENABLE_SENDER_SIGNING,
} from '../EditorOverlayActions/ActionTypes';

export const DEFAULT_STATE = false;

const SIGNATURE_MODES = [
  EditorOverlayStateEnum.REQUEST_SIGNATURE,
  EditorOverlayStateEnum.REQUEST_SIGNATURE_FILL,
  EditorOverlayStateEnum.REQUEST_SIGNATURE_WAIT,
  EditorOverlayStateEnum.SENDER_SIGNING,
  EditorOverlayStateEnum.COMPOSE_REQUEST_SIGNERS,
  EditorOverlayStateEnum.COMPOSE_REQUEST_FIELDS,
  EditorOverlayStateEnum.COMPOSE_REQUEST_MESSAGE,
];

const NON_SIGNATURE_MODES = [
  EditorOverlayStateEnum.EDIT,
  EditorOverlayStateEnum.SIGN,
  EditorOverlayStateEnum.VIEW,
];

const decideRequestSignatureExperience = (state, mode) => {
  if (SIGNATURE_MODES.includes(mode)) {
    return true;
  } else if (NON_SIGNATURE_MODES.includes(mode)) {
    return false;
  }
  return state;
};

const isRequestSignatureExperience = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_EDITOR_MODE:
      return decideRequestSignatureExperience(state, action.mode);
    case ENABLE_EDIT:
    case ENABLE_VIEW:
    case ENABLE_SIGN:
    case ENABLE_REQUEST_SIGNATURE:
    case ENABLE_REQUEST_SIGNATURE_WAIT:
    case ENABLE_REQUEST_SIGNATURE_FILL:
    case ENABLE_SENDER_SIGNING:
      return decideRequestSignatureExperience(state, ACTION_MODE_MAP[action.type]);
    default:
      return state;
  }
};

export default isRequestSignatureExperience;



// WEBPACK FOOTER //
// ./src-react/EditorOverlay/EditorOverlayReducer/isRequestSignatureExperience.jsx